import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import LegalPage from "./LegalPage";
import { BUSINESS } from "@/lib/business";

const CONTENT = {
  ar: {
    eyebrow: "قانوني",
    title: "سياسة الخصوصية",
    updatedAt: "٢٤ فبراير ٢٠٢٦",
    intro:
      "نحن في DAAM نأخذ خصوصية بياناتك على محمل الجدّ. توضّح هذه السياسة نوع البيانات التي نجمعها، ولماذا نجمعها، ومدة الاحتفاظ بها، ومع من تُشارك.",
    sections: [
      { title: "١. البيانات التي نجمعها",
        paragraphs: ["نقوم بجمع البيانات التالية:"],
        list: [
          "بيانات الحساب: الاسم، البريد الإلكتروني، كلمة المرور المُشفّرة، الدور.",
          "بيانات الاشتراك والدفع: خطة الاشتراك، تاريخ التجديد، مُعرّف عميل Tap، آخر ٤ أرقام من البطاقة، حالة الاشتراك. لا نُخزّن رقم البطاقة الكامل أو رمز الأمان.",
          "بيانات الاستخدام: طلبات توليد المحتوى (صور، فيديو، محادثات ذكاء اصطناعي)، إحصائيات الحصص، سجلات الأخطاء.",
          "الحسابات الاجتماعية المرتبطة: توكن TikTok/Instagram الذي منحته لنا، الحد الأدنى من بيانات الملف العام.",
          "البيانات التقنية: عنوان IP، متصفح، سجلات الوصول.",
        ]},
      { title: "٢. لماذا نستخدم بياناتك",
        list: [
          "تشغيل خدمات DAAM وتوليد المحتوى المطلوب.",
          "إدارة الاشتراك والفوترة عبر Tap Payments.",
          "منع الاحتيال والاستخدام السيّئ.",
          "تحسين المنتج وتحليل الأداء الإجمالي (مجموعات مجمّعة، غير مرتبطة بمُعرّف شخصي).",
          "إرسال إشعارات الحساب، تذكير التجديد، والدعم.",
        ]},
      { title: "٣. مدة الاحتفاظ",
        paragraphs: [
          "نحتفظ ببيانات الحساب طالما بقي الحساب نشطاً. عند حذف الحساب، تُحذف بياناتك خلال ٩٠ يوماً باستثناء ما يجب الاحتفاظ به لأغراض محاسبية أو قانونية (سجلات الفواتير: ١٠ سنوات وفق أنظمة المملكة).",
          "المحتوى المُولَّد (صور، فيديو) يُحتفظ به داخل حسابك حتى تقوم بحذفه أو حتى ٣٠ يوماً بعد إغلاق الحساب.",
        ]},
      { title: "٤. الأمان",
        paragraphs: [
          "نستخدم HTTPS لجميع الاتصالات، تشفير كلمات المرور باستخدام bcrypt، مفاتيح JWT قصيرة العمر، ومكتبة تشفير معتمدة لأي بيانات حساسة مخزّنة.",
          "لا يمكن لأي شخص داخل DAAM قراءة كلمة المرور الخاصة بك؛ نحن نقرأ فقط الهاش المُشفّر.",
        ]},
      { title: "٥. أطراف ثالثة (معالجات البيانات)",
        paragraphs: ["نستعين بالمزوّدين التاليين لتقديم الخدمة. جميعهم ملتزمون بمعايير أمن معلومات معتمدة:"],
        list: [
          "Tap Payments — معالجة الدفع (بيانات البطاقة والفوترة).",
          "Resend — إرسال البريد الإلكتروني (الاسم، البريد، رمز التحقق).",
          "TikTok — عند ربط حسابك (توكن الحساب، البيانات العامة).",
          "مزوّدو نماذج الذكاء الاصطناعي (Claude, Gemini, OpenAI Sora) — لمعالجة طلبات توليد المحتوى النصية والوسائط.",
          "MongoDB Atlas / Emergent — استضافة قاعدة البيانات والتطبيق.",
        ]},
      { title: "٦. حقوقك",
        list: [
          "طلب نسخة من بياناتك الشخصية.",
          "تصحيح أي بيانات غير دقيقة.",
          "حذف حسابك ومعه بياناتك (ضمن حدود الالتزامات القانونية).",
          "سحب موافقتك على ربط الحسابات الاجتماعية في أي وقت.",
        ]},
      { title: "٧. ملفات تعريف الارتباط (Cookies)",
        paragraphs: [
          "نستخدم ملفات تعريف ارتباط ضرورية لتسجيل الدخول (JWT)، وملفات تفضيلات اللغة والسمة. لا نستخدم ملفات تتبّع إعلاني.",
        ]},
      { title: "٨. DAAM Leads — قياس روابط التواصل",
        paragraphs: [
          "تستخدم ميزة DAAM Leads بيانات تقنية محدودة لقياس زيارات صفحات الروابط والنقرات على أزرار التواصل. لا نخزن عنوان IP بصورته الأصلية، ولا نخزن محتوى رسائل واتساب. يُحوّل عنوان IP إلى معرّف يومي مشفّر، ويُحتفظ بأحداث القياس لمدة تصل إلى ١٨٠ يومًا. النتائج المعروضة تقديرية ولا تعني إتمام طلب أو عملية بيع.",
        ]},
      { title: "٩. التواصل معنا",
        paragraphs: [`للاستفسارات حول الخصوصية أو ممارسة أي من حقوقك أعلاه: ${BUSINESS.email_legal}`,
                     `العنوان: ${BUSINESS.address_ar}`]},
    ],
  },
  en: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    updatedAt: "February 24, 2026",
    intro:
      "At DAAM we take your privacy seriously. This policy explains what data we collect, why we collect it, how long we keep it, and who we share it with.",
    sections: [
      { title: "1. Data we collect",
        paragraphs: ["We collect the following data:"],
        list: [
          "Account data: name, email address, hashed password, role.",
          "Subscription and payment metadata: plan, renewal date, Tap customer id, last 4 digits of the card, subscription status. We never store the full card number or security code.",
          "Usage data: content-generation requests (images, videos, AI chats), quota telemetry, error logs.",
          "Connected social accounts: the TikTok/Instagram access token you grant us and minimal public-profile data.",
          "Technical data: IP address, browser, access logs.",
        ]},
      { title: "2. Why we use your data",
        list: [
          "Operating DAAM and generating the content you request.",
          "Managing subscriptions and billing via Tap Payments.",
          "Preventing fraud and abuse.",
          "Improving the product and understanding aggregate performance (aggregated only, not linked to a personal identifier).",
          "Sending account notifications, renewal reminders and support responses.",
        ]},
      { title: "3. Retention",
        paragraphs: [
          "We keep account data while your account remains active. On account deletion your data is removed within 90 days, except records we must keep for accounting or regulatory reasons (invoice records: 10 years under KSA regulations).",
          "Generated content (images, videos) is retained inside your account until you delete it or until 30 days after account closure.",
        ]},
      { title: "4. Security",
        paragraphs: [
          "We use HTTPS for all connections, bcrypt for password hashing, short-lived JWT keys, and an approved encryption library for any sensitive data at rest.",
          "No DAAM employee can read your password; only the hashed representation is stored.",
        ]},
      { title: "5. Third parties (data processors)",
        paragraphs: ["We rely on the following providers. Each is bound by industry-standard information-security commitments:"],
        list: [
          "Tap Payments — payment processing (card and billing data).",
          "Resend — transactional email (name, email, verification codes).",
          "TikTok — when you connect your account (account token, public data).",
          "AI model providers (Claude, Gemini, OpenAI Sora) — to process text and media generation requests.",
          "MongoDB Atlas / Emergent — database and application hosting.",
        ]},
      { title: "6. Your rights",
        list: [
          "Request a copy of your personal data.",
          "Correct any inaccurate data.",
          "Delete your account and its data (subject to legal retention obligations).",
          "Withdraw consent for connected social accounts at any time.",
        ]},
      { title: "7. Cookies",
        paragraphs: [
          "We use cookies strictly required for login (JWT) and language / theme preferences. We do not use advertising trackers.",
        ]},
      { title: "8. DAAM Leads — link click measurement",
        paragraphs: [
          "The DAAM Leads feature uses limited technical data to measure visits to link pages and clicks on contact buttons. We never store the raw IP address, and we never store the content of WhatsApp messages. The IP is transformed into an encrypted daily identifier, and measurement events are retained for up to 180 days. The figures shown are estimates and do not imply a completed order or sale.",
        ]},
      { title: "9. Contact us",
        paragraphs: [`For privacy enquiries or to exercise any right above: ${BUSINESS.email_legal}`,
                     `Address: ${BUSINESS.address}`]},
    ],
  },
};

export default function PrivacyPage() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.en;
  return (
    <LegalPage testId="privacy-page" eyebrow={c.eyebrow} title={c.title}
      updatedAt={c.updatedAt} intro={c.intro} sections={c.sections} />
  );
}
